import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth(); // Destructure loading state

  // While checking for authentication, show a loading screen or null
  if (loading) {
    // You can replace this with a proper loading spinner component
    return <div>Loading...</div>; 
  }

  // After loading, if there's no user, redirect to login
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // If authenticated, render the requested component
  return children;
};

export default ProtectedRoute;